exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app .message-pop-content{width:13rem;left:50%;margin-left:-6.5rem;height:8rem;border-radius:.15rem}.app .message-box-title{border-radius:.15rem .15rem 0 0}.app .message-scroll{border-radius:0 0 .15rem .15rem}.app .popup-message-box{background-color:rgba(0,0,0,.5)}.app .tip-content{text-align:center;padding:1.75rem 0}.app a.disabled{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de9d6cba","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/familyDoctor/NoSigned.vue
// module id = 490
// module chunks = 0